import React from 'react';
import CommonIcon from './icons';
import $ from "jquery";

function warningNohandle() {
    $("body").removeClass("scrollhide");
}

function WarningComponent({ id = null, message, isMobile, onYesClick, type, mappingData }) {

    return (
        <>
            {/* {$("#CancelCourseScreen").hasClass("show") ? (
        <div className="viewbar-overlay"></div>
      ) : (
        <></>
      )} */}
            {$("#" + (id ? id : "CancelCourseScreen")).hasClass("show") ? (
                <div className="viewbar-overlay"></div>
            ) : (
                <></>
            )}
            <div
                className="modal fade modal-style"
                data-bs-backdrop="static"
                id={id ? id : "CancelCourseScreen"}
                tabIndex={-1}
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-dialog-centered modal-lg"
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-header pb-2 pl-20">
                            <h5
                                className="modal-title d-flex pl-10"
                                id="exampleModalLongTitle"
                            >
                                {
                                    mappingData?.length > 0 ?
                                        <>
                                            <CommonIcon fileName="FailedIcon" />
                                            &nbsp;<span className="mt-1 pl-5"></span>Failed to Delete
                                        </>
                                        :
                                        <>
                                            <CommonIcon fileName="WarningIcon" />
                                            &nbsp;<span className="mt-1 pl-5"></span>Warning
                                        </>
                                }
                            </h5>
                            {mappingData?.length > 0 ?
                                <>
                                    <button
                                        className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`}
                                        onClick={() => { warningNohandle() }}
                                        data-bs-dismiss="modal"
                                    >
                                        {/* <img src={CrossIcon} className="cursor-pointer app-image-hover" /> */}
                                        <CommonIcon fileName="CrossIcon" className="cursor-pointer app-image-hover" />
                                    </button>
                                </>
                                : <></>
                            }
                        </div>
                        <div className="modal-body pl-20">
                            <h5 className="warning-text">
                                {message}
                            </h5>
                        </div>
                        {
                            (type && mappingData?.length > 0) &&
                            <div className="px-3 mb-5">
                                <table width="100%" className="px-3">
                                    <thead>
                                        <tr className="border-bottom">
                                            <th className="py-2" width="15%">S.No</th>
                                            <th className="py-2" width="85%">{type}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            mappingData?.length > 0 &&
                                            mappingData?.map((item, index) => (
                                                <>
                                                    <tr className="border-bottom" key={index}>
                                                        <td className="py-2">{index + 1}</td>
                                                        <td className="py-2">{item}</td>
                                                    </tr>
                                                </>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                {/* <h5 className="warning-text mt-4">
                                {`Are you sure you want to remove ${(type == "Level" || type == "Skill") ? "this" : "these"}  ${type} ?` }
                            </h5> */}
                            </div>
                        }
                        {
                            mappingData?.length > 0 ? "" :
                                <>
                                    <div className="modal-footer border-top-none justify-content-center pb-3">
                                        <button className={`btn input-group ${isMobile ? "warning-btn-mobile" : "rejectbutton"}`} data-bs-dismiss="modal"
                                            onClick={() => { warningNohandle() }}
                                        >No </button>
                                        <button className={`btn input-group ${isMobile ? "filter-nextMobilebtn" : "approvebutton"}`} data-bs-dismiss="modal" onClick={() => onYesClick()}>Yes</button>
                                    </div>
                                </>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default WarningComponent;